import { Select, MenuItem, ListSubheader, FormControl } from '@mui/material';
import { type Config, type FieldProps } from '@react-awesome-query-builder/mui';

export default function MaterialOperatorSelect({
	items,
	setField,
	selectedKey,
	readonly,
	placeholder
}: FieldProps<Config>) {
	const renderOptions = (fields, level = 0) =>
		Object.keys(fields).map(fieldKey => {
			const field = fields[fieldKey];
			const { items: fieldItems, path, label, disabled } = field;
			const prefix = '\u00A0\u00A0'.repeat(level);
			if (fieldItems) {
				return [
					<ListSubheader key={path} disableSticky>
						{label}
					</ListSubheader>,
					renderOptions(fieldItems, level + 1)
				];
			}
			return (
				<MenuItem disabled={disabled} key={path} value={path}>
					{prefix && <span>{prefix}</span>}
					{label}
				</MenuItem>
			);
		});

	const onChange = e => {
		if (e.target.value === undefined) return;
		setField(e.target.value);
	};

	const renderValue = selectedValue => {
		if (!readonly && !selectedValue) return placeholder;
		const findLabel = fields => {
			return fields.map(field => {
				if (!field.items) return field.path === selectedValue ? field.label : null;
				return findLabel(field.items);
			});
		};
		return findLabel(items)
			.filter(v => {
				if (Array.isArray(v)) {
					return v.some(value => value !== null);
				}
				return v !== null;
			})
			.pop();
	};

	const hasValue = selectedKey != null;
	return (
		<FormControl>
			<Select
				variant="outlined"
				size="small"
				autoWidth
				displayEmpty
				onChange={onChange}
				value={hasValue ? selectedKey : ''}
				renderValue={renderValue}
				disabled={readonly}
			>
				{renderOptions(items)}
			</Select>
		</FormControl>
	);
}
